export default __webpack_public_path__ + "static/media/pond.1ecf7132.jpg";